import { render, staticRenderFns } from "./queryPrice.vue?vue&type=template&id=a73ec9b0&scoped=true&"
import script from "./queryPrice.vue?vue&type=script&lang=js&"
export * from "./queryPrice.vue?vue&type=script&lang=js&"
import style0 from "./queryPrice.vue?vue&type=style&index=0&id=a73ec9b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73ec9b0",
  null
  
)

export default component.exports